'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function () {
	'use strict';

	// Usage:
	// 
	// Creates:
	// 

	HistoricalDataController.$inject = ['$q', '$stateParams', '$timeout', '$translate', 'download', 'iotService', 'measurementsService', 'settingsService'];
	angular.module('app.iot').component('historicalData', {
		require: { app: '^app' },
		template: '<div style="padding: 2em 0em;"><div class="container-fluid" translate-namespace="iot"><div class="row"><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><ol class="breadcrumb pull-left"><li ng-repeat="breadcrumb in $ctrl.app.breadcrumbs"><a href="{{breadcrumb.url}}">{{breadcrumb.label | translate}}</a></li><li><a ui-sref="iot" translate-namespace="iot" translate>.Urban environment monitoring</a></li><li translate-namespace="iot" translate>.Historical data</li></ol><div class="pull-right"><login-widget></login-widget></div></div></div><div class="row"><div class="col-xs-12 col-sm-12 col-mg-3 col-lg-3"><aside class="well" style="background-color: white;"><div class="row"><div class="col-lg-12"><div class="btn-group btn-group-justified" style="margin-bottom:1em;" ng-init="category_name_attr = (\'category.name\' | translate)"><label class="btn btn-default" uib-btn-radio="category" ng-repeat="category in $ctrl.form.categoryOptions" ng-model="$ctrl.form.category" ng-click="$ctrl.onCategoryChange()">{{category[category_name_attr]}}</label></div></div><div class="col-lg-12" ng-if="$ctrl.form.category.slug == \'water-resources\'"><div class="alert alert-warning"><i class="fa fa-exclamation-triangle"></i> <span translate>.warning-disclamer</span></div></div><div class="col-lg-12"><div class="form-group"><label for="fois" class="control-label" translate>.Locations</label> <small class="pull-right legend-right"><a ng-click="$ctrl.onSelectAllFois()" translate>.Add all</a> - <a ng-click="$ctrl.onRemoveAllFois()" translate>.Remove all</a></small><ui-select id="fois" ng-init="foi_name_attr = (\'foi.name\' | translate)" data-multiple close-on-select="false" search-enabled="false" ng-model="$ctrl.form.states[$ctrl.form.category.id].fois" data-on-select="$ctrl.onFoiSelect($item)" data-on-remove="$ctrl.onFoiRemove($item)" ui-select-placeholder="{{$ctrl.translations[\'iot.Add more locations\']}}" placeholder="{{$ctrl.translations[\'iot.Add more locations\']}}"><ui-select-match placeholder="{{$ctrl.translations[\'iot.Add more locations\']}}"><span class="color-bullet" ng-style="{\'background-color\': $item.color}"></span> <span data-ng-bind="$item[foi_name_attr]"></span></ui-select-match><ui-select-choices data-repeat="o in ($ctrl.form.states[$ctrl.form.category.id].foiOptions | orderBy:foi_name_attr | filter: $select.search) track by o.id"><span class="color-bullet" ng-style="{\'background-color\': o.color}"></span> <span data-ng-bind="o[foi_name_attr]"></span></ui-select-choices></ui-select></div></div><div class="col-xs-12 col-sm-4 col-md-4 col-lg-12"><div class="form-group"><label for="modality" class="control-label" translate>.Modality</label><select id="modality" ng-init="modality_name_attr = (\'modality.name\' | translate)" class="form-control input-sm" ng-model="$ctrl.form.states[$ctrl.form.category.id].modality" ng-options="o as o[modality_name_attr] for o in $ctrl.form.states[$ctrl.form.category.id].modalityOptions | orderBy:(modality_name_attr) track by o.slug" ng-change="$ctrl.onModalityChange()"></select></div></div><div class="col-xs-12 col-sm-4 col-md-4 col-lg-6"><div class="form-group" ng-class="{\'has-error\': !$ctrl.form.isValid}"><label for="date-range" class="control-label" translate>.Dates range</label> <input id="date-range" date-range-picker="t1" class="form-control input-sm" start-date="$ctrl.form.states[$ctrl.form.category.id].from" end-date="$ctrl.form.states[$ctrl.form.category.id].to" date-range-picker-options="$ctrl.uiConfig.dateRangePicker" clear-on-cancel="true" on-change="$ctrl.onDateRangeChange()"></div></div><div class="col-xs-12 col-sm-4 col-md-4 col-lg-6"><div class="form-group" ng-class="{\'has-error\': !$ctrl.form.isValid, \'invisible\': $ctrl.form.modality.slug == \'wind-history\'}"><label for="granularity" class="control-label" translate>.Aggregation</label><select id="granularity" ng-init="granularity_name_attr = (\'granularity.name\' | translate)" ng-disabled="$ctrl.form.isWindSelected" ng-model="$ctrl.form.states[$ctrl.form.category.id].granularity" ng-options="o as o[granularity_name_attr] for o in $ctrl.form.states[$ctrl.form.category.id].granularityOptions track by o.id" ng-change="$ctrl.onGranularityChange()" class="form-control input-sm"></select></div></div><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12" ng-if="!$ctrl.form.isValid"><div class="text-danger small" style="padding-bottom:1em;" translate>.Invalid Dates and Aggregation combination</div></div><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><div class="btn-group btn-block" role="group" translate-namespace="common.download-button"><button type="button" class="btn btn-block btn-default dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"><span translate>.Download</span> <span class="caret"></span></button><ul class="dropdown-menu"><li><a data-ng-click="$ctrl.download(\'csv\')" translate>.CSV file</a></li><li><a data-ng-click="$ctrl.download(\'png\')" translate>.Image</a></li><li><a data-ng-click="$ctrl.download(\'svg\')" translate>.Vector image</a></li></ul></div></div></div></aside></div><div class="col-xs-12 col-sm-12 col-mg-12 col-lg-9"><div class="panel panel-default" style="padding-top:1em;padding-bottom:1em;"><h4 class="title text-center">{{$ctrl.title}}</h4><div class="subtitle text-center">{{$ctrl.subtitle}}</div><nvd3 ng-if="$ctrl.form.modality.slug != \'wind-history\'" class="nvd3-chart" options="$ctrl.uiConfig.lineChart.options" config="$ctrl.uiConfig.lineChart.config" data="$ctrl.chart"></nvd3><nvd3 ng-if="$ctrl.form.modality.slug == \'wind-history\'" class="nvd3-chart" options="$ctrl.uiConfig.windHistoryChart.options" config="$ctrl.uiConfig.windHistoryChart.config" data="$ctrl.windChart"></nvd3></div></div></div></div></div>',
		controller: HistoricalDataController,
		controllerAs: '$ctrl'
	});

	function HistoricalDataController($q, $stateParams, $timeout, $translate, download, iotService, measurementsService, settingsService) {
		'ngInject';

		var $ctrl = this;

		////////////////

		$ctrl.$onInit = function () {

			$ctrl.form = new FormModel();
			$ctrl.uiConfig = new UiConfig($ctrl.form, measurementsService);

			if ($stateParams.water) {
				$stateParams.category = 2;
			}

			$q.all({
				categories: iotService.getCategories(),
				modalities: iotService.getModalities(),
				fois: iotService.getInfrastructure(),
				granularities: measurementsService.getGranularities(),
				formDefaults: settingsService.getValue('Visualizer/historicalData/defaults', {}),
				translations: getTranslations()
			}).then(function (r) {

				/* Merge form defaults with state parameters */
				var params = _.mergeWith(r.formDefaults, $stateParams, function (oVal, sVal, key, o, s, stack) {
					return _.isArray(oVal) ? sVal : !s[key] ? o[key] : undefined;
				});

				$ctrl.translations = r.translations;

				$ctrl.uiConfig.setTranslations($ctrl.translations);
				$ctrl.form.initialize(r.categories, r.fois, r.modalities, r.granularities);
				$ctrl.form.setDefaults(params);

				$ctrl.updateChart();
				$ctrl.onSelectAllFois();
			}).catch(function (error) {
				console.error('Oops! Something went wrong!', error);
			});
		};

		/**
   * 
   */
		$ctrl.$onDestroy = function () {
			destroyTooltips();
		};

		/**
   * 
   */
		$ctrl.onCategoryChange = function () {
			$ctrl.updateChart();
		};

		/**
   * 
   */
		$ctrl.onModalityChange = function () {
			$ctrl.updateChart();
		};

		/**
   * 
   */
		$ctrl.onGranularityChange = function () {
			$ctrl.updateChart();
		};

		/**
   * 
   */
		$ctrl.onDateRangeChange = function () {
			$ctrl.updateChart();
		};

		/**
   * 
   */
		$ctrl.onShowOutOfRangeChange = function () {
			$ctrl.updateChart();
		};

		/**
   * 
   * @param {*} foi 
   */
		$ctrl.onFoiSelect = function (foi) {
			if ($ctrl.form.isWindHistorySelected) {
				$ctrl.updateChart();
			} else {
				addFoi(foi);
			}
		};

		/**
   * 
   * @param {*} foi 
   */
		$ctrl.onFoiRemove = function (foi) {
			if ($ctrl.form.isWindHistorySelected) {
				$ctrl.updateChart();
			} else {
				removeFoi(foi);
			}
		};

		/**
   * 
   */
		$ctrl.onSelectAllFois = function () {
			$ctrl.form.foiOptions.forEach(function (foi) {
				if (!_.find($ctrl.form.fois, { id: foi.id })) {
					$ctrl.form.fois.push(foi);
					$ctrl.onFoiSelect(foi);
				}
			});
		};

		/**
   * 
   */
		$ctrl.onRemoveAllFois = function () {
			$ctrl.form.fois.forEach(function (foi) {
				$ctrl.onFoiRemove(foi);
			});
			_.remove($ctrl.form.fois, function (o) {
				return true;
			});
		};

		/**
   * [updateChart description]
   * @return {[type]} [description]
   */
		$ctrl.updateChart = function () {

			hideTooltips();

			if (!$ctrl.form.isValid) {
				return;
			}

			if ($ctrl.form.isWindHistorySelected) {
				$ctrl.windChart = {
					calmness: 0,
					ranges: []
				};
				measurementsService.getWindHistory($ctrl.form.fois, $ctrl.form.from, $ctrl.form.to).then(function (data) {
					// var colors = ['#2c7bb6', '#00c4c1', '#cef88f', '#fcea73', '#f7bf47', '#f09227', '#e66118', '#d7191c'];
					var colors = ['#cef88f', '#f7bf47', '#e66118', '#d7191c'];
					data.ranges.forEach(function (entry, index) {
						entry.color = colors[index];
					});
					$ctrl.windChart = data;
				});
			} else {
				clearForceY();
				$ctrl.chart = [];
				$ctrl.form.fois.forEach(function (foi) {
					addFoi(foi);
				});
			}

			setTitle();
			setSubtitle();
		};

		/**
   * [downloadChart description]
   * @param  {[type]} type [description]
   */
		$ctrl.download = function (type) {
			var $svg, data, filename;

			filename = $ctrl.form.toFilename(type);

			switch (type) {
				case 'csv':
					data = Papa.unparse(getChartData(), { quotes: true, delimiter: ';' });
					download.fromDataURL("data:text/csv;charset=utf-8,%EF%BB%BF" + encodeURI(data), filename);
					break;
				case 'png':
					$svg = angular.element('.nvd3-chart > svg');
					svgAsPngUri($svg[0], { backgroundColor: '#ffffff' }, function (uri) {
						return download.fromDataURL(uri, filename);
					});
					break;
				case 'svg':
					$svg = angular.element('.nvd3-chart > svg');
					svgAsDataUri($svg[0], { backgroundColor: '#ffffff' }, function (uri) {
						return download.fromDataURL(uri, filename);
					});
					break;
			}
		};

		////////////////////////////////////////////////////////////////////////

		function destroyTooltips() {
			angular.element('.nvtooltip.xy-tooltip').remove();
		}

		function hideTooltips() {
			angular.element('.nvtooltip.xy-tooltip').css('opacity', 0);
		}

		/**
   * [downloadChartData description]
   * @return {[type]} [description]
   */
		function getChartData() {
			var data = [];

			if ($ctrl.form.isWindHistorySelected) {

				$ctrl.windChart.ranges.forEach(function (group, index) {
					var column;

					if (index == 0) {
						column = _.concat([$ctrl.translations['Speed (km/h)']], $ctrl.uiConfig.windHistoryChart.options.chart.directions);
						data.push(column);
					}

					/* Create data column. Concatenate column name with values */
					column = _.concat(group.key.join(' to '), _.map(group.values, function (o) {
						return d3.format(',.3f')(o);
					}));
					data.push(column);
				});
			} else {
				$ctrl.chart.forEach(function (foi, index) {
					var column;

					/* Add dates column */
					if (index == 0) {
						/* Create Dates column. Concatenate header with date values */
						column = _.concat($ctrl.translations['iot.Date'], _.map(foi.values, function (o) {
							return moment(o.at).format();
						}));
						data.push(column);
					}

					/* Create data column. Concatenate column name with values */
					column = _.concat(foi.key, _.map(foi.values, 'avg'));
					data.push(column);
				});
			}

			return _.unzip(data);
		}

		/**
   * 
   * @param {*} foi 
   */
		function addFoi(foi) {
			hideTooltips();

			return getFoiData(foi).then(function (data) {
				addFoiDataToForceY(data);

				$ctrl.chart.push(data);
				hideTooltips();
			});
		}

		/**
   * 
   * @param {*} data 
   */
		function addFoiDataToForceY(data) {
			var min = _.get(data, 'min.avg'),
			    max = _.get(data, 'max.avg');

			if (!(isNaN(min) || isNaN(max))) {
				var diff = max - min,
				    normalizedMin,
				    normalizedMax;

				normalizedMin = Math.floor(min - diff * 0.15);
				normalizedMax = Math.floor(max + diff * 0.15);

				if (!$ctrl.form.showOutOfRange) {
					normalizedMin = Math.max(normalizedMin, $ctrl.form.modality.min_value);
					normalizedMax = Math.min(normalizedMax, $ctrl.form.modality.max_value);
				}

				diff = normalizedMax - normalizedMin;

				if (diff < 10) {
					normalizedMax += 10 - diff;
				}

				$ctrl.uiConfig.lineChart.options.chart.forceY.push(normalizedMin);
				$ctrl.uiConfig.lineChart.options.chart.forceY.push(normalizedMax);
			}
		}

		/**
   * 
   */
		function clearForceY() {
			$ctrl.uiConfig.lineChart.options.chart.forceY = [];
		}

		/**
   * 
   * @param {*} foi 
   */
		function removeFoi(foi) {

			hideTooltips();

			clearForceY();

			_($ctrl.chart).reject({ id: foi.id }).each(function (o) {
				addFoiDataToForceY(o);
				hideTooltips();
			});

			_.remove($ctrl.chart, { id: foi.id });
		}

		/**
   * 
   * @param {*} foi 
   */
		function getFoiData(foi) {

			return measurementsService.getAggregated($ctrl.form.modality, [foi], $ctrl.form.from, $ctrl.form.to, $ctrl.form.granularity, $ctrl.form.showOutOfRange).then(function (res) {
				return {
					id: foi.id,
					key: foi[$ctrl.translations['foi.name']],
					color: foi.color,
					min: res.min,
					max: res.max,
					values: res.measurements
				};
			});
		}

		/**
   * 
   */
		function getTranslations() {
			return $translate(['foi.name', 'modality.name', 'category.name', 'iot.Add more locations', 'iot.Calm', 'iot.Date', 'iot.Speed (km/h)', 'compass.N', 'compass.NNE', 'compass.NE', 'compass.ENE', 'compass.E', 'compass.ESE', 'compass.SE', 'compass.SSE', 'compass.S', 'compass.SSW', 'compass.SW', 'compass.WSW', 'compass.W', 'compass.WNW', 'compass.NW', 'compass.NNW']);
		}

		/**
   * 
   * @param {*} text 
   */
		function setTitle() {
			var text = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

			var modality = $ctrl.form.modality,
			    nameAttr = $ctrl.translations['modality.name'],
			    title;

			title = text || '' + modality[nameAttr];

			$ctrl.title = title;
		}

		/**
   * 
   * @param {*} text 
   */
		function setSubtitle() {
			var text = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
			var _$ctrl$form = $ctrl.form,
			    from = _$ctrl$form.from,
			    to = _$ctrl$form.to,
			    subtitle;


			subtitle = text || from.format('DD MMM YYYY') + ' - ' + to.format('DD MMM YYYY');

			$ctrl.subtitle = subtitle;
		}

		/**
   * 
   */

		var FormModel = function () {
			function FormModel() {
				_classCallCheck(this, FormModel);

				this.category = undefined;
				this.maxDataPointsPerPlot = 1000, this.states = {};
			}

			_createClass(FormModel, [{
				key: 'getter',
				value: function getter(attribute, value) {
					return this.category ? this.states[this.category.id][attribute] : undefined;
				}
			}, {
				key: 'setter',
				value: function setter(attribute, value) {
					this.category ? this.states[this.category.id][attribute] = value : undefined;
				}
			}, {
				key: 'initialize',
				value: function initialize(categories, fois, modalities, granularities) {
					var _this = this;

					this.categoryOptions = categories;

					var extraModalities = [{ slug: 'wind-history', name: 'Wind History', name_el: 'Άνεμος, Ιστορικό', unit: 'km/h' }];

					categories.forEach(function (category) {
						var colorScale = d3.scale.category10();
						var filteredFois = iotService.filterFoisByModalityIds(fois, category.modality_ids);
						var modalityOptions = iotService.filterModalitiesByIds(modalities, category.modality_ids);

						if (category.id === 1) {
							modalityOptions = _.concat(modalityOptions, extraModalities);
						}

						filteredFois.forEach(function (o, i) {
							o.color = colorScale(i);
						});

						_this.states[category.id] = {
							fois: [],
							foiOptions: filteredFois,
							modality: undefined,
							modalityOptions: modalityOptions,
							granularity: undefined,
							granularityOptions: granularities
						};
					});
				}
			}, {
				key: 'setDefaults',
				value: function setDefaults(defaultValues) {
					var _this2 = this;

					this.category = _.find(this.categoryOptions, { 'id': defaultValues.category });

					this.categoryOptions.forEach(function (category) {
						var state = _this2.states[category.id];
						var defaults = defaultValues.categories[category.id];

						state.fois = _.filter(state.foiOptions, _.conforms({ id: _.partial(_.includes, defaults.fois) }));
						state.modality = _.find(state.modalityOptions, { 'id': defaults.modality });
						state.granularity = _.find(state.granularityOptions, { 'id': defaults.granularity });

						state.from = moment().add(defaults.from.value, defaults.from.unit).startOf('day');
						state.to = moment().add(defaults.to.value, defaults.to.unit).endOf('hour');
					});
				}
			}, {
				key: 'toFilename',
				value: function toFilename(extension) {
					var _states$category$id = this.states[this.category.id],
					    modality = _states$category$id.modality,
					    from = _states$category$id.from,
					    to = _states$category$id.to,
					    granularity = _states$category$id.granularity;


					if ($ctrl.form.isWindSelected) {
						return 'Wind from ' + from.format('D-MMM-YY') + ' to ' + to.format('D-MMM-YY') + '.' + extension;
					}

					return modality.name + ' from ' + from.format('D-MMM-YY') + ' to ' + to.format('D-MMM-YY') + ' ' + granularity.name + '.' + extension;
				}
			}, {
				key: 'countPlotPoints',
				value: function countPlotPoints() {
					var count = 0;
					if (this.from && this.to && this.granularity) {
						count = this.to.diff(this.from, this.granularity.unit) / this.granularity.value;
					}
					return count;
				}
			}, {
				key: 'fois',
				get: function get() {
					return this.getter('fois');
				},
				set: function set(value) {
					this.setter('fois', value);
				}
			}, {
				key: 'foiOptions',
				get: function get() {
					return this.getter('foiOptions');
				},
				set: function set(value) {
					this.setter('foiOptions', value);
				}
			}, {
				key: 'modality',
				get: function get() {
					return this.getter('modality');
				},
				set: function set(value) {
					this.setter('modality', value);
				}
			}, {
				key: 'modalityOptions',
				get: function get() {
					return this.getter('modalityOptions');
				},
				set: function set(value) {
					this.setter('modalityOptions', value);
				}
			}, {
				key: 'granularity',
				get: function get() {
					return this.getter('granularity');
				},
				set: function set(value) {
					this.setter('granularity', value);
				}
			}, {
				key: 'granularityOptions',
				get: function get() {
					return this.getter('granularityOptions');
				},
				set: function set(value) {
					this.setter('granularityOptions', value);
				}
			}, {
				key: 'to',
				get: function get() {
					return this.getter('to');
				},
				set: function set(value) {
					this.setter('to', value);
				}
			}, {
				key: 'from',
				get: function get() {
					return this.getter('from');
				},
				set: function set(value) {
					this.setter('from', value);
				}
			}, {
				key: 'showOutOfRange',
				get: function get() {
					return this.getter('showOutOfRange');
				},
				set: function set(value) {
					this.setter('showOutOfRange', value);
				}
			}, {
				key: 'isWindHistorySelected',
				get: function get() {
					return this.modality ? this.modality.slug === 'wind-history' : false;
				}
			}, {
				key: 'isValid',
				get: function get() {
					return this.isWindHistorySelected || this.countPlotPoints() <= this.maxDataPointsPerPlot;
				}
			}]);

			return FormModel;
		}();

		/**
   * 
   */


		var UiConfig = function () {
			function UiConfig(form, measurementsService) {
				_classCallCheck(this, UiConfig);

				this.select2 = { searchEnabled: false };
				this.dataRangePicker = {
					locale: {
						format: 'DD/MM/YYYY',
						separator: ' - '
					}
				};

				this.lineChart = new LineChartConfig(form, measurementsService);
				this.windHistoryChart = new WindHistoryChartConfig(form, measurementsService);
			}

			_createClass(UiConfig, [{
				key: 'setTranslations',
				value: function setTranslations(i18n) {
					this.lineChart.setTranslations(i18n);
					this.windHistoryChart.setTranslations(i18n);
				}
			}]);

			return UiConfig;
		}();

		/**
   * 
   */


		var LineChartConfig = function () {
			function LineChartConfig(form, measurementsService) {
				_classCallCheck(this, LineChartConfig);

				this.form = form;
				this.toBeaufort = measurementsService.toBeaufort;
				this.toCompass = measurementsService.toCompass;

				this.config = {
					deepWatchOptions: true,
					deepWatchData: true,
					deepWatchDataDepth: 1
				};

				this.options = {
					title: { enable: false },
					subtitle: { enable: false },

					chart: {

						id: 'lineChart',
						type: 'lineWithFocusChart',
						useInteractiveGuideline: true,

						height: 550,
						duration: 250,

						margin: { top: 20, right: 60, bottom: 60, left: 80 },
						legend: { margin: { top: 10, right: 0, bottom: 10, left: 0 } },

						defined: function defined(d, i) {
							return d.avg !== null;
						},

						x: function x(d) {
							return d.at;
						},
						y: function y(d) {
							return d.avg;
						},

						forceY: [],
						xScale: d3.time.scale(),
						focus: { xScale: d3.time.scale() },

						xAxis: { tickFormat: this.timeFormatter() },
						x2Axis: { tickFormat: this.timeFormatter() },
						yAxis: { tickFormat: d3.format(',.0f') },
						y2Axis: { tickFormat: d3.format(',.0f') },

						interactiveLayer: {
							tooltip: {
								headerFormatter: this.tooltipHeaderFormatter(),
								valueFormatter: this.tooltipValueFormatter()
							}
						}
					}
				};
			}

			_createClass(LineChartConfig, [{
				key: 'setTranslations',
				value: function setTranslations(i18n) {
					this.compass = [i18n['compass.N'], i18n['compass.NNE'], i18n['compass.NE'], i18n['compass.ENE'], i18n['compass.E'], i18n['compass.ESE'], i18n['compass.SE'], i18n['compass.SSE'], i18n['compass.S'], i18n['compass.SSW'], i18n['compass.SW'], i18n['compass.WSW'], i18n['compass.W'], i18n['compass.WNW'], i18n['compass.NW'], i18n['compass.NNW']];
				}
			}, {
				key: 'timeFormatter',
				value: function timeFormatter() {
					return d3.currentLocale.timeFormat.multi([['%H:%M', function (d) {
						return d.getHours();
					}], ['%a %d', function (d) {
						return d.getDay() && d.getDate() != 1;
					}], ['%d %b', function (d) {
						return d.getDate() != 1;
					}], ['%B', function (d) {
						return d.getMonth();
					}], ['%Y', function (d) {
						return true;
					}]]);
				}
			}, {
				key: 'tooltipHeaderFormatter',
				value: function tooltipHeaderFormatter() {
					var _this3 = this;

					return d3.currentLocale.timeFormat.multi([['%d/%m/%Y %H:%M', function (d) {
						return _this3.form.granularity.unit == 'hour';
					}], ['%d/%m/%Y', function (d) {
						return _this3.form.granularity.id == 'days';
					}], ['%d/%m/%Y', function (d) {
						return _this3.form.granularity.id == 'weeks';
					}], ['%B %Y', function (d) {
						return _this3.form.granularity.id == 'months';
					}]]);
				}
			}, {
				key: 'tooltipValueFormatter',
				value: function tooltipValueFormatter() {
					var self = this;

					return function (d, i, entry) {
						var output = '-';

						if (!isNaN(d) && d !== null) {
							output = d3.format(',.2f')(d) + '  ' + self.form.modality.unit;

							if ($ctrl.form.modality.slug === 'wind-speed') {
								output += '<span>' + self.toBeaufort(d, true) + ' Bf</span> <span>' + self.toCompass(entry.data.dir, self.compass, '') + '</span>';
							}
						}

						return output;
					};
				}
			}]);

			return LineChartConfig;
		}();

		/**
   * 
   */


		var WindHistoryChartConfig = function () {
			function WindHistoryChartConfig(form, measurementsService) {
				_classCallCheck(this, WindHistoryChartConfig);

				this.form = form;

				this.toBeaufort = measurementsService.toBeaufort;

				this.config = {
					deepWatchOptions: true,
					deepWatchData: true,
					deepWatchDataDepth: 1
				};

				this.options = {
					title: { enable: false },
					subtitle: { enable: false },

					chart: {
						id: 'windHistoryChart',
						type: 'windroseChart',
						height: 550,
						duration: 500,

						directions: [],
						calmLabel: 'Calm',

						directionValues: function directionValues(d) {
							return d.values;
						},
						directionValueFormat: function directionValueFormat(d) {
							return d ? d3.format(',.2f')(d) + '%' : '-';
						},

						key: function key(d) {
							return d.key;
						},
						keyFormat: this.keyFormatter()
					}
				};
			}

			_createClass(WindHistoryChartConfig, [{
				key: 'keyFormatter',
				value: function keyFormatter() {
					var self = this;

					return function (d) {
						var bf1 = self.toBeaufort(d.key[0], false),
						    bf2 = self.toBeaufort(d.key[1], true),
						    output = bf1 + '+ Bf (' + d.key[0] + '+ km/h)';

						if (d.key[1]) {
							output = bf1 + '-' + bf2 + ' Bf (' + d.key[0] + '-' + d.key[1] + ' km/h)';
						}

						return output;
					};
				}
			}, {
				key: 'setTranslations',
				value: function setTranslations(i18n) {
					this.options.chart.directions = [i18n['compass.N'], i18n['compass.NNE'], i18n['compass.NE'], i18n['compass.ENE'], i18n['compass.E'], i18n['compass.ESE'], i18n['compass.SE'], i18n['compass.SSE'], i18n['compass.S'], i18n['compass.SSW'], i18n['compass.SW'], i18n['compass.WSW'], i18n['compass.W'], i18n['compass.WNW'], i18n['compass.NW'], i18n['compass.NNW']];

					this.options.chart.calmLabel = i18n['iot.Calm'];
				}
			}]);

			return WindHistoryChartConfig;
		}();
	}
})();